import React from "react";
import PageForm from "../form";

const CancellationPolicy = ({ group }: { group: string }) => {
  return <PageForm title="Cancellation Policy" Key={`${group}-cancellation-policy`} />;
};

export default CancellationPolicy;
